var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"btn",class:'btn-' + _vm.type,attrs:{"type":"button","disabled":_vm.disabled}},_vm.$listeners),[_c('i',{staticClass:"glyphicon",class:'glyphicon-' + _vm.icon})])}
var staticRenderFns = []

export { render, staticRenderFns }